export default {
    // A
    addPhoto: 'Add photo',

    // B
    backgroundColor: 'Background color',

    // C
    chooseBackgroundColor: 'Choose a background color',
    createGroup: 'Create group',

    overview: {
        title: 'Groups',
        description: 'Bring people and content together around a team, project, or topic.',
        quickStart: {
            howItWorks: 'How groups work',
            dismiss: 'Dismiss groups guide',
            eyebrow: 'Working together',
            titleFirst: 'The right people.',
            titleSecond: 'One shared space.',
            description: 'Give each team or project a place to share content and stay connected.',
            sectionsLabel: 'Getting started with groups',
            sections: {
                create: {
                    title: 'Create a group',
                    description: 'Choose a name and description so people know what belongs here.',
                },
                access: {
                    title: 'Choose who can join',
                    description: 'Make it public for channel members to join, or private for invited members.',
                },
                share: {
                    title: 'Invite and share',
                    description: 'Add members, then share content with the group to keep everyone in the loop.',
                },
            },
            footnote: 'Already see a group for your team? Join it below. Private groups require approval.',
        },
    },
    list: {
        open: 'Open group',
        join: 'Join group',
        leave: 'Leave group',
        delete: 'Delete group',
        cancelRequest: 'Cancel request',
        options: 'More options for {name}',
        editAction: 'Edit group',
        aboutAction: 'About this group',
        noDescription: 'A shared space for this group’s people and content.',
        mine: 'My groups',
        discover: 'Groups you can join',
        search: 'Search groups',
        clearSearch: 'Clear search',
        sort: 'Sort by',
        newest: 'Newest first',
        oldest: 'Oldest first',
        alphabetical: 'Name, A to Z',
        popular: 'Most members',
        emptyTitle: 'Your next collaboration starts here',
        emptyDescription: 'Create a group for your team or project, then invite people and share content.',
        joinDescription: 'Join a group below, or create a space for your own team or project.',
        noJoinedTitle: 'You haven’t joined a group yet',
        noResultsTitle: 'No groups found',
        noResultsDescription: 'Try another name or clear your search to see all groups.',
        noJoinedResults: 'No joined groups match your search.',
        private: 'Private',
        public: 'Public',
        requested: 'Request pending',
        about: 'About {name}',
        edit: 'Edit {name}',
    },

    confirm: {
        leaveTitle: 'Leave this group?',
        leaveDescription: 'You’ll no longer see this group’s content in your feed.',
        keepMembership: 'Keep membership',
        leave: 'Leave group',
        cancelTitle: 'Cancel your join request?',
        cancelDescription: 'You can request to join this group again later.',
        keepRequest: 'Keep request',
        cancel: 'Cancel request',
    },

    deletion: {
        title: 'Delete group?', description: 'will be deleted. This action cannot be undone.',
        confirmLabel: 'Type “{name}” to confirm', exactMatch: 'The group name must match exactly.',
        delete: 'Delete group', deleting: 'Deleting…',
    },

    workspace: {
        postToGroup: 'Post to {name}', groupPostPlaceholder: 'Share something with {name}…',
        postPublished: 'Post shared with your group', postFailed: 'Couldn’t share this post. Try again.',
        postTooLarge: 'This attachment is over 5 GB. Choose a smaller file.',
        breadcrumb: 'Group navigation', backToFeed: 'Back to feed', myGroups: 'My groups', searchGroups: 'Search groups',
        myGroupsInfo: 'About my groups', myGroupsHelp: 'Switch between groups you’ve joined, or browse all groups in your channel.',
        discoverGroups: 'Discover groups', browseGroups: 'Browse all groups', showMore: 'Show more', noMatches: 'No groups match your search.',
        members: '{count} member | {count} members', member: 'Member', membersTab: 'Members', content: 'Content', about: 'About', sections: 'Group sections',
        groupContent: 'Group content', noDescription: 'A place for your team to share ideas, updates, and content.',
        copyLink: 'Copy group link', shareTitle: 'Share with your group', shareDescription: 'Keep your team’s videos and updates in one place.',
        record: 'Record', upload: 'Upload', request: 'Request', emptyTitle: 'Your group starts here',
        emptyDescription: 'Record a video or upload existing media to start sharing with this group.',
        recordHint: 'Capture a new video', uploadHint: 'Share existing media',
        joinTitle: 'No shared content yet', joinDescription: 'Join this group to record and upload content with its members.',
        loading: 'Loading content…', errorTitle: 'Couldn’t load group content', errorDescription: 'Try again to see the latest content.',
        retry: 'Try again', moreContent: 'Load more content', allContent: 'You’re all caught up.',
        searchMembers: 'Search members', owner: 'Group owner', noMembers: 'No members match your search.',
        joinedOn: 'Joined {date}', joinDateUnknown: 'Join date not recorded',
        contributions: '{count} contribution | {count} contributions',
        previous: 'Previous', next: 'Next', page: 'Page {page} of {total}', aboutTitle: 'About this group',
        privateGroup: 'Private group', publicGroup: 'Public group',
        privateHelp: 'Only members can see group content. Others can find the group and request to join.',
        publicHelp: 'Anyone in your channel can see group content and join.',
        actionError: 'Couldn’t update this group. Try again.', joinSuccess: 'Membership updated', leaveSuccess: 'Membership updated', deleteSuccess: 'Group deleted',
        leaveTitle: 'Leave this group?', leaveDescription: 'You’ll no longer see this group’s content in your feed.',
        deleteTitle: 'Delete this group?', deleteDescription: 'This permanently deletes the group. This action cannot be undone.',
        cancelDescription: 'You can request to join this group again later.',
    },

    image: {
        title: 'Group image',
        description: 'Help people recognize your group at a glance.',
        close: 'Close group image editor',
        groupFallback: 'Your group',
        preview: 'Group preview',
        photoTab: 'Photo',
        colorTab: 'Color',
        emojiTab: 'Emoji',
        emojiHelp: 'Choose an emoji to represent your group.',
        emojiChoices: 'Group emojis',
        customEmoji: 'Or paste an emoji',
        invalidEmoji: 'Choose or paste one emoji.',
        applying: 'Applying…',
        applyError: 'Couldn’t create this avatar. Try again.',
        photoHelp: 'Choose a square photo or logo that represents your group.',
        uploadPhoto: 'Upload photo',
        changePhoto: 'Change photo',
        resetPhoto: 'Undo photo change',
        fileHelp: 'Square images work best. Up to 2 MB.',
        colorHelp: 'Choose a background for your initials or emoji.',
        colorWithPhotoHelp: 'Used for your initials icon. Your photo stays unchanged.',
        colorChoices: 'Background color',
        currentColor: 'Current',
        applyHelp: 'Apply to preview, then save the group to keep your changes.',
        apply: 'Apply',
        unsupportedFile: 'Choose a supported image, such as a JPG, PNG, or WEBP file.',
        tooLarge: 'This image is over 2 MB. Choose a smaller file.',
        colors: { charcoal: 'Charcoal', graphite: 'Graphite', moss: 'Moss', clay: 'Clay', ash: 'Ash', stone: 'Stone', sand: 'Sand', offWhite: 'Off-white' },
    },

    // R
    replacePhoto: 'Replace photo',
}
